import { render } from "./Moderations.vue?vue&type=template&id=1ee0bb44&scoped=true"
import script from "./Moderations.vue?vue&type=script&lang=js"
export * from "./Moderations.vue?vue&type=script&lang=js"

import "./Moderations.vue?vue&type=style&index=0&id=1ee0bb44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee0bb44"]])

export default __exports__